import { sendRequest } from '../../config';

export interface addFollowUpParams {
    //campos obligatorios
    cpais: string;
    nlocaliza: string;
    xdetalle: string;
    cetiqueta: string

    //campos opcionales -- aqui se pueden ir agregando todos los demas campos que en el futuro puedan requerirse
    cusuario?: string;
}

export interface dataAddFollowUp {
    description?: string;
}

export const addFollowUp = async (params: addFollowUpParams[]): Promise<dataAddFollowUp> => {

    const ENDPOINT = 'v2/localizador/addFollowUp';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: {
            cpais: params[0].cpais,
            nlocaliza: Number(params[0].nlocaliza),
            xdetalle: params[0].xdetalle,
            cetiqueta: params[0].cetiqueta,
        },
    });
};

